export enum WebSocketMessageType {
  'NEW_MESSAGE' = 'messages.update',
  'NEW_ALERT_MESSAGE' = 'alerts.update',
  'FILE_STATE_UPDATE' = 'files.update'
}

export enum DashboardTabsEnum {
  APPLICATIONS = 'applications',
  DOCUMENTS = 'documents',
  MESSAGES = 'messages'
}

export enum ProcessStatus {
  FILE_PENDING = 'filepending',
  FILE_VALIDATED = 'filevalidated',
  FILE_DECLINE = 'filedecline',
  FILE_REJECT = 'filereject'
}
